import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LocalStorage } from 'src/app/core/utils/local.storage';
import { AuthService } from 'src/app/core/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { ChangePasswordComponent } from 'src/app/account/components/change-password/change-password.component';
import { ErrorModel } from 'src/app/core/models/error.model';
import { UpdatePicService } from 'src/app/main/configuracao/services/update-pic.service';
import { UsuarioDTOModel } from 'src/app/account/models/usuario-dto.model';
import { LoginService } from 'src/app/core/services/login.service';

@Component({
  selector: 'app-user-profile-menu',
  templateUrl: './user-profile-menu.component.html',
  styleUrls: ['./user-profile-menu.component.scss']
})
export class UserProfileMenuComponent implements OnInit {
  helpLink: string;
  nomeCompleto$: Observable<string>;
  perfil$: Observable<string>;
  foto: string = null;

  constructor(
    private authService: AuthService,
    public dialog: MatDialog,
    private updatePicService: UpdatePicService,
    private loginService: LoginService,
  ) {}

  ngOnInit(): void {
    const userDTO: UsuarioDTOModel = LocalStorage.getItem('usuarioSistemaDTO');
    if (userDTO) {
      this.nomeCompleto$ = of(userDTO.nome);
      this.foto = !!userDTO.foto ? userDTO.foto : null;
    }

    this.updatePicService.service().subscribe(foto => {
      const usuarioSistemaDTO: any = LocalStorage.getItem('usuarioSistemaDTO');
      if ((!foto || foto == 'null') && !!usuarioSistemaDTO) {
        this.foto = usuarioSistemaDTO.foto;
        return;
      }

      this.foto = foto;
    });

    this.loginService.getLoginData().subscribe(row => {
      if (!!row) {
        this.nomeCompleto$ = of(row.nome);
      }
    });
  }

  logout(): void {
    this.authService.logout();
  }

  trocarSenha(): void {
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      width: '600px',
      height: '550px',
      data: {},
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result instanceof ErrorModel) {
        return;
      }
      // tslint:disable-next-line:no-unused-expression
      !!result && alert('Senha alterada com sucesso');
    });
  }
}
